<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Global
        <span class="separator" />
      </h1>
    </b-col>
    <ListeStatsGlobal />
  </div>
</template>

<script>
import ListeStatsGlobal from "@/components/stats/ListeStatsGlobal.vue";

export default {
  name: "StatsGlobal",
  components: {
    ListeStatsGlobal,
  },
};
</script>

<style lang="scss" scoped>
</style>
